import {useEffect} from 'react';

const SITE_URL='https://omakase.hk';
const SHARE_IMAGE='https://media-manager-c.questera.ai/greta-media/048a294ccd6718892c549bd7b643fcf120d7d84b38289b7b4b78889b4f78a748e8c921a45f072a6a0302366ee1557436/images/aW1hZ2UvanBlZw==/83aaf939a9be57beeb20518337283270.jpg';

const pages={
  home:{
    path:'',
    zh:{
      title:'OMAKASE.HK｜旬心料亭與百層旬之淵',
      description:'探索旬心料亭、裏・板前學院、板前血脈，以及百層旬之淵的料理世界。'
    },
    en:{
      title:'OMAKASE.HK | Shunshin Ryotei and Shun no Fuchi',
      description:'Explore Shunshin Ryotei, its secret academy, itamae bloodlines and the one hundred floors of Shun no Fuchi.'
    }
  },
  academy:{
    path:'academy/',
    zh:{
      title:'裏・板前學院｜OMAKASE.HK',
      description:'了解裏・板前學院如何透過旬、刀、火候、血脈與手癖，培養一名能獨立獻食的板前。'
    },
    en:{
      title:'Secret Itamae Academy | OMAKASE.HK',
      description:'Discover how the secret academy trains an itamae through seasonality, blades, fire, bloodline and personal Kuse.'
    }
  },
  characters:{
    path:'characters/',
    zh:{
      title:'人物名鑑｜紅澪與玉澄｜OMAKASE.HK',
      description:'瀏覽旬心料亭人物名鑑，認識板前紅澪與玉澄的血脈、手癖、組別與人物故事。'
    },
    en:{
      title:'Character Archive | Kuremio and Tamasumi | OMAKASE.HK',
      description:'Browse the Shunshin character archive and meet Kuremio and Tamasumi.'
    }
  },
  'character-kuremio':{
    path:'characters/kuremio/',
    image:'https://media-manager-c.questera.ai/greta-media/048a294ccd6718892c549bd7b643fcf120d7d84b38289b7b4b78889b4f78a748e8c921a45f072a6a0302366ee1557436/images/aW1hZ2UvanBlZw==/024766f5fd25eb20670673974c6ba2a9.jpg',
    zh:{
      title:'紅澪 Kuremio｜人物檔案｜OMAKASE.HK',
      description:'紅澪是旬心料亭向付組的味之連結者。了解她的鮭之血脈、手癖「燃」、人物性格與下淵故事。'
    },
    en:{
      title:'Kuremio | Character Profile | OMAKASE.HK',
      description:'Meet Kuremio, the Mukozuke Division connector of tastes, and discover her salmon bloodline and Kuse, Moe.'
    }
  },
  'character-tamasumi':{
    path:'characters/tamasumi/',
    image:'https://media-manager-c.questera.ai/greta-media/048a294ccd6718892c549bd7b643fcf120d7d84b38289b7b4b78889b4f78a748e8c921a45f072a6a0302366ee1557436/images/aW1hZ2UvanBlZw==/75d3787f081804f7eabe0898b072a4b3.jpg',
    zh:{
      title:'玉澄 Tamasumi｜人物檔案｜OMAKASE.HK',
      description:'玉澄是旬心料亭焼物組的守火之人。了解她的玉子血脈、手癖「安」、人物性格與守火故事。'
    },
    en:{
      title:'Tamasumi | Character Profile | OMAKASE.HK',
      description:'Meet Tamasumi, keeper of fire in the Yakimono Division, and discover her tamago bloodline and Kuse, An.'
    }
  },
  story:{
    path:'story/',
    zh:{
      title:'旬心物語｜OMAKASE.HK',
      description:'閱讀旬心料亭的故事，從聞心、定下旬題、深入百層旬之淵，到完成一期一會的一席獻食。'
    },
    en:{
      title:'The Story of Shunshin | OMAKASE.HK',
      description:'Follow the journey from listening to a guest heart and descending into the Abyss to completing one unrepeatable offering.'
    }
  },
  bloodline:{
    path:'bloodline/',
    zh:{
      title:'板前血脈與手癖｜OMAKASE.HK',
      description:'認識紅澪、玉澄與其他板前血脈，以及手癖如何改變一席料理與客人的心境。'
    },
    en:{
      title:'Itamae Bloodline and Kuse | OMAKASE.HK',
      description:'Meet Kuremio, Tamasumi and the itamae bloodlines whose Kuse transforms each culinary offering.'
    }
  },
  abyss:{
    path:'abyss/',
    zh:{
      title:'旬之淵百層｜OMAKASE.HK',
      description:'深入旬之淵一百層，探索各層生態、旬味、守護者、場景與可回收料理記憶。'
    },
    en:{
      title:'The 100 Floors of Shun no Fuchi | OMAKASE.HK',
      description:'Descend through one hundred floors of ecosystems, seasonal ingredients, guardians and recoverable culinary memories.'
    }
  }
};

function ensureMeta(selector,attributes){
  let element=document.head.querySelector(selector);

  if(!element){
    element=document.createElement('meta');
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([name,value])=>{
    element.setAttribute(name,value);
  });
}

function ensureLink(hrefLang,href){
  const selector=`link[rel="alternate"][hreflang="${hrefLang}"]`;
  let element=document.head.querySelector(selector);

  if(!element){
    element=document.createElement('link');
    element.rel='alternate';
    element.hreflang=hrefLang;
    document.head.appendChild(element);
  }

  element.href=href;
}

function setJsonLd(page,data,lang,canonical,image,pageKey){
  const element=document.getElementById('website-schema');
  if(!element)return;

  const isCharacter=pageKey.startsWith('character-');

  element.textContent=JSON.stringify({
    '@context':'https://schema.org',
    '@type':isCharacter?'ProfilePage':page.path?'WebPage':'WebSite',
    '@id':`${canonical}#webpage`,
    name:data.title,
    url:canonical,
    description:data.description,
    inLanguage:lang==='en'?'en':'zh-Hant',
    isPartOf:{
      '@type':'WebSite',
      '@id':`${SITE_URL}/#website`,
      name:'OMAKASE.HK',
      url:`${SITE_URL}/`
    },
    image
  });
}

export default function SeoHead({lang,pageKey='home'}){
  useEffect(()=>{
    const page=pages[pageKey]||pages.home;
    const data=lang==='en'?page.en:page.zh;
    const zhUrl=`${SITE_URL}/${page.path}`;
    const enUrl=`${SITE_URL}/en/${page.path}`;
    const canonical=lang==='en'?enUrl:zhUrl;
    const locale=lang==='en'?'en_HK':'zh_HK';
    const image=page.image||SHARE_IMAGE;

    document.title=data.title;
    document.documentElement.lang=lang;

    ensureMeta('meta[name="description"]',{
      name:'description',
      content:data.description
    });
    ensureMeta('meta[name="language"]',{name:'language',content:lang});
    ensureMeta('meta[property="og:title"]',{
      property:'og:title',
      content:data.title
    });
    ensureMeta('meta[property="og:description"]',{
      property:'og:description',
      content:data.description
    });
    ensureMeta('meta[property="og:locale"]',{
      property:'og:locale',
      content:locale
    });
    ensureMeta('meta[property="og:url"]',{
      property:'og:url',
      content:canonical
    });
    ensureMeta('meta[property="og:image"]',{
      property:'og:image',
      content:image
    });
    ensureMeta('meta[name="twitter:title"]',{
      name:'twitter:title',
      content:data.title
    });
    ensureMeta('meta[name="twitter:description"]',{
      name:'twitter:description',
      content:data.description
    });
    ensureMeta('meta[name="twitter:image"]',{
      name:'twitter:image',
      content:image
    });

    const canonicalLink=document.head.querySelector('link[rel="canonical"]');
    if(canonicalLink)canonicalLink.href=canonical;

    ensureLink('zh-Hant',zhUrl);
    ensureLink('en',enUrl);
    ensureLink('x-default',zhUrl);
    setJsonLd(page,data,lang,canonical,image,pageKey);
  },[lang,pageKey]);

  return null;
}